import { z } from 'zod';
import { requiredBoolean } from '@/shared/validation/common.schemas';

/**
 * Parental Approval Form Schema
 *
 * Validates parental consent form for ELEV users.
 * All checkbox fields are required (must be true).
 * Signature must be a non-empty base64 string.
 */
export const parentalApprovalSchema = z.object({
  // Required boolean checkboxes - all must be checked
  parentApproval: requiredBoolean(
    'In calitate de tutore al elevului, imi dau aprobarea pentru participarea acestuia in cadrul programului educational Scoala Ecoterrienilor.'
  ),

  prinPrezentaConfirmamInscriereaMinorului: requiredBoolean(
    'Prin prezenta confirmam inscrierea minorului in Campania „Scoala Ecoterrienilor"'
  ),

  ecoticPoateFolosiImagini: requiredBoolean(
    'ECOTIC poate folosi imagini in care pot aparea participantii'
  ),

  amFostInformati: requiredBoolean(
    'Am fost informati despre modul de desfasurare al campaniei'
  ),

  prinPrezentaConfirmCaAmCititInformarea: requiredBoolean(
    'Prin prezenta confirm ca am citit Informarea cu privire la prelucrarea datelor mele cu caracter personal'
  ),

  confirmCaInCazulInCareProiectul: requiredBoolean(
    'Confirm ca in cazul in care proiectul inscris include imagini cu persoane, acestea si-au dat consimtamantul expres'
  ),

  consimtPentruPastrareaDatelorPersonale: requiredBoolean(
    'Consimt pentru pastrarea datelor personale ale minorului in baza de date a ASOCIATIEI ECOTIC'
  ),

  amCititSiSuntDeAcord: requiredBoolean(
    'Am citit si sunt de acord cu Nota de Informare si Regulamentul Campaniei'
  ),

  // Signature field - must be non-empty base64 string
  signature: z.string().min(1, 'Nu a fost completata semnatura parintelui. Asigurati-va ca dupa completare apasati bifa verde.'),
});

export type ParentalApprovalFormData = z.infer<typeof parentalApprovalSchema>;
